module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "tac not-found"
  }, [_c('span', {
    staticClass: "not-found-number"
  }, [_vm._v("404")]), _vm._v(" "), _c('span', {
    staticClass: "not-found-info"
  }, [_vm._v("not found")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-895b64f2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotFound.vue
// module id = 127
// module chunks = 2